import React from 'react'
import PropTypes from 'prop-types'
import ReactCountUp from 'react-countup'

const CountUp = ({ start = 0, to = 0, duration = 2.5, decimals }) => (
  <ReactCountUp
    start={start}
    end={to}
    delay={0}
    duration={duration}
    decimals={decimals}
    useEasing={false}
    separator=','
  >
    {({ countUpRef }) => <span ref={countUpRef} />}
  </ReactCountUp>
)

CountUp.propTypes = {
  start: PropTypes.number,
  to: PropTypes.number,
  duration: PropTypes.number,
  decimals: PropTypes.number,
}

export default CountUp
